import { Divider, Grid, Typography } from "@material-ui/core";
import icon from "assets/imgs/icon.png";
import React from "react";

export default function VerQuadros() {
  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={3}
        style={{ padding: "15px", textAlign: "center" }}
      >
        <Grid item xs={12} style={{ marginBottom: "15px" }}>
          <img src={icon} height="100px" />
          <Typography variant="h3">Ver Quadros</Typography>
          <Divider />
        </Grid>
      </Grid>
    </div>
  );
}
